export default {
	setPersonWithAudit(state, value) {
		state.personWithAudit = value;
	},
	setOneAudits(state, value) {
		if (value) state.oneAudit = value;
		else state.oneAudit = null;
	},
};
